// Fallback defaults — mirrors backend/default_content.py exactly so the UI never breaks.
export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Global Luxury Real Estate Advisory",
    heading_line1: "Invest in Dubai's Finest Real Estate",
    heading_accent: "with Confidence.",
    subheading:
      "We advise global investors, entrepreneurs, and affluent families in acquiring exceptional Dubai real estate — delivering outstanding lifestyle experiences and carefully evaluated long-term investment opportunities.",
    cta_label: "Schedule Private Consultation",
    cta_href: "#contact",
    background_image:
      "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg",
    trust_stats: [
      { k: "15+", v: "Years Experience" },
      { k: "40+", v: "Premium Developments" },
      { k: "30+", v: "International Client Countries" },
      { k: "Trusted", v: "Investment Advisory" },
    ],
  },
  who_we_are: {
    eyebrow: "Who We Are",
    heading_line1: "More Than Real Estate Brokers.",
    heading_accent: "We Are Investment Advisors.",
    body_paragraphs: [
      "Purchasing luxury real estate is one of the most consequential financial decisions our clients make. We begin by understanding your objectives — never by promoting projects.",
      "Whether your priority is preserving wealth, building a global property portfolio, generating rental income, or acquiring a world-class residence, our role is to guide you with clarity, transparency, and market insight.",
    ],
    italic_quote:
      "If we believe a project does not align with your goals, we will tell you. Because trust matters more than transactions.",
    image: "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg",
    stats: [
      { k: "AED 1.2B+", v: "Transaction Value" },
      { k: "30+", v: "Countries Served" },
      { k: "40+", v: "Luxury Developments" },
      { k: "68%", v: "Client Referral Business" },
    ],
  },
  why_dubai: {
    eyebrow: "Why Dubai",
    heading: "Why Global Investors Continue Choosing Dubai",
    intro:
      "Dubai has established itself as one of the world's most attractive destinations for global capital — combining economic stability, infrastructure development, international connectivity, and premium lifestyle opportunities.",
    cards: [],
  },
  philosophy: {
    eyebrow: "Our Investment Philosophy",
    heading: "Every recommendation follows a structured investment framework.",
    intro: "",
    steps: [],
    closing_statement:
      "Only after completing this evaluation do we recommend an opportunity to our clients.",
  },
  opportunities: {
    eyebrow: "Featured Opportunities",
    heading: "Selected Investment Opportunities",
    intro:
      "Curated from dozens of new and ready developments — reviewed against our six-part framework.",
    cta_label: "Request More Details",
  },
  trending: {
    eyebrow: "",
    heading: "Dubai's Upcoming Projects",
    intro:
      "Stay ahead of the market and discover Dubai's most anticipated upcoming developments before they launch. From branded residences to master-planned communities, get early access to investment opportunities with strong growth potential.",
    sub_intro:
      "If you're a savvy investor looking to secure the right property before prices rise, our experts can help you identify the upcoming project that best matches your investment goals.",
    cta_label: "Enquire Now",
    coming_soon_label: "COMING SOON",
    pre_launch_label: "Pre-Launch",
  },
  process: { eyebrow: "Our Advisory Process", heading: "", steps: [] },
  trust: { eyebrow: "Why Clients Trust Us", heading: "", cards: [] },
  insights: {
    eyebrow: "Market Insights",
    heading: "Knowledge creates better investments.",
    intro: "",
    resources: [],
  },
  testimonials: {
    eyebrow: "Client Testimonials",
    heading: "Trusted by investors around the world.",
    items: [],
  },
  cta: {
    eyebrow: "Private Consultation",
    heading: "Let's discuss your investment goals.",
    body: "",
    background_image:
      "https://images.pexels.com/photos/30554306/pexels-photo-30554306.jpeg",
    submit_label: "Schedule Private Consultation",
    privacy_statement:
      "Your information is treated with complete confidentiality and will only be used to respond to your enquiry.",
    whatsapp_label: "WhatsApp · +971 58 612 4320",
    whatsapp_url: "https://wa.me/+971586124320",
    instagram_label: "Instagram · @dxbpropertyzone",
    instagram_url:
      "https://www.instagram.com/dxbpropertyzone?igsh=MXl2enFidWp6aGRq",
    budgets: [
      "Under AED 3M",
      "AED 3M – 7M",
      "AED 7M – 15M",
      "AED 15M – 30M",
      "AED 30M+",
    ],
    objectives: [
      "Lifestyle Residence",
      "Capital Appreciation",
      "Rental Income",
      "Portfolio Diversification",
    ],
    consultations: ["Video Call", "Office Meeting", "Phone Call"],
  },
  footer: {
    tagline: "",
    whatsapp_label: "WhatsApp · +971 58 612 4320",
    whatsapp_url: "https://wa.me/+971586124320",
    instagram_label: "@dxbpropertyzone",
    instagram_url:
      "https://www.instagram.com/dxbpropertyzone?igsh=MXl2enFidWp6aGRq",
    copyright: "DXB Property Zone. Luxury Real Estate Investment Advisory.",
  },
  whatsapp_float: { url: "https://wa.me/+971586124320" },
  navbar: {
    brand_prefix: "DXB",
    brand_suffix: "Property Zone",
    cta_label: "Consult",
  },
};

// Deep-merge helper: keys in `override` win, arrays are taken as-is from override when present.
export function mergeContent(base, override) {
  if (override == null) return base;
  if (Array.isArray(base) || Array.isArray(override)) return override ?? base;
  if (typeof base === "object" && typeof override === "object") {
    const out = { ...base };
    for (const k of Object.keys(override)) {
      out[k] = mergeContent(base[k], override[k]);
    }
    return out;
  }
  return override ?? base;
}
